var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MyCenter"},[_c('van-nav-bar',{attrs:{"fixed":"","title":"载体展示","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('Jlmap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }